import { useState, useContext } from "react";
import "./accountSecurity.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import usersRequest from "../../../request/usersRequest";
import BannerMessage from "../../common/bannerMessage/bannerMessage";
import { useNavigate } from "react-router-dom";

const AccountSecurity = () => {
    const { language, userData, setUserData } = useContext(CombinedContext);

    const userEmail = userData?.user?.email || userData?.email || "";
    const accessToken = userData?.cognitoTokens?.AccessToken || userData?.accessToken;

    const [email, setEmail] = useState(userEmail);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [toast, setToast] = useState("");
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [deleting, setDeleting] = useState(false);

	const navigate = useNavigate()

    async function handleResetPassword(e) {
        e.preventDefault();
        if (!email) return;

        try {
            setLoading(true);
            setToast("");
            await usersRequest.forgotPassword(email);
            setSuccess(true);
        } catch (err) {
            console.error(err);
            setToast(translations[language].account.forgotPassword.toast.error);
        } finally {
            setLoading(false);
        }
    }

    async function handleDeleteAccount() {
        try {
            setDeleting(true);
            await usersRequest.removeSelf(accessToken);
            localStorage.removeItem("idToken");
            localStorage.removeItem("accessToken");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("user");
            sessionStorage.removeItem("idToken");
            sessionStorage.removeItem("accessToken");
            sessionStorage.removeItem("refreshToken");
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("shop");
            setUserData(null);
            navigate("/signin");
        } catch (err) {
            console.error(err);
            setShowDeleteConfirm(false);
            setToast(
                language === "es"
                    ? "Error al eliminar la cuenta. Inténtalo de nuevo."
                    : "Failed to delete account. Please try again."
            );
        } finally {
            setDeleting(false);
        }
    }

    return (
        <div className="sf-security-page">
            <h2 className="sf-security-title">{translations[language].account.security?.title || "Security"}</h2>

            {/* EMAIL */}
            <div className="sf-security-section">
                <h3 className="sf-security-section-title">
                    {translations[language].account.security?.emailTitle || "Email"}
                </h3>
                <div className="sf-security-email-display">{email || "—"}</div>
            </div>

            {/* RESET PASSWORD */}
            <div className="sf-security-section">
                <h3 className="sf-security-section-title">
                    {translations[language].account.security?.passwordTitle || "Reset Password"}
                </h3>

                {success ? (
                    <p className="sf-security-success">{translations[language].account.forgotPassword.success}</p>
                ) : (
                    <form className="sf-security-form" onSubmit={handleResetPassword}>
                        <p className="sf-security-sub">{translations[language].account.forgotPassword.subtitle}</p>
                        <div className="sf-security-row">
                            <input
                                type="email"
                                className="sf-security-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                            <button type="submit" className="sf-security-button" disabled={loading}>
                                {loading
                                    ? translations[language].account.forgotPassword.sending
                                    : translations[language].account.forgotPassword.send}
                            </button>
                        </div>
                    </form>
                )}
            </div>

            {/* DELETE ACCOUNT */}
            <div className="sf-security-section">
                <h3 className="sf-security-section-title">
                    {language === "es" ? "Eliminar cuenta" : "Delete Account"}
                </h3>
                <p className="sf-security-sub">
                    {language === "es"
                        ? "Esta acción es permanente y no se puede deshacer."
                        : "This action is permanent and cannot be undone."}
                </p>
                <button
                    className="sf-security-button sf-security-button--danger"
                    onClick={() => setShowDeleteConfirm(true)}
                >
                    {language === "es" ? "Eliminar cuenta" : "Delete Account"}
                </button>
            </div>

            {/* CONFIRM MODAL */}
            {showDeleteConfirm && (
                <div className="sf-delete-overlay" onClick={() => setShowDeleteConfirm(false)}>
                    <div className="sf-delete-modal" onClick={(e) => e.stopPropagation()}>
                        <h3>{language === "es" ? "¿Eliminar tu cuenta?" : "Delete your account?"}</h3>
                        <p>
                            {language === "es"
                                ? "Todos tus datos serán eliminados de forma permanente. Esta acción no se puede deshacer."
                                : "All your data will be permanently deleted. This cannot be undone."}
                        </p>
                        <div className="sf-delete-modal-actions">
                            <button onClick={() => setShowDeleteConfirm(false)} disabled={deleting}>
                                {language === "es" ? "Cancelar" : "Go back"}
                            </button>
                            <button
                                className="sf-security-button--danger"
                                onClick={handleDeleteAccount}
                                disabled={deleting}
                            >
                                {deleting
                                    ? language === "es"
                                        ? "Eliminando..."
                                        : "Deleting..."
                                    : language === "es"
                                    ? "Sí, eliminar"
                                    : "Yes, delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {toast && <BannerMessage text={toast} />}
        </div>
    );
};

export default AccountSecurity;

// import { useState, useContext } from "react";
// import "./accountSecurity.css";
// import { CombinedContext } from "../../../context/combinedContext";
// import translations from "../../../translations/translations";
// import usersRequest from "../../../request/usersRequest";
// import BannerMessage from "../../common/bannerMessage/bannerMessage";

// const AccountSecurity = () => {
// 	const { language, userData } = useContext(CombinedContext);

// 	const userEmail =
// 		userData?.user?.email ||
// 		userData?.email ||
// 		"";

// 	const [email, setEmail] = useState(userEmail);
// 	const [loading, setLoading] = useState(false);
// 	const [success, setSuccess] = useState(false);
// 	const [toast, setToast] = useState("");

// 	async function handleResetPassword(e) {
// 		e.preventDefault();
// 		if (!email) return;

// 		try {
// 			setLoading(true);
// 			setToast("");

// 			await usersRequest.forgotPassword(email);
// 			setSuccess(true);
// 		} catch (err) {
// 			console.error(err);
// 			setToast(
// 				translations[language].account.forgotPassword.toast.error
// 			);
// 		} finally {
// 			setLoading(false);
// 		}
// 	}

// 	return (
// 		<div className="sf-security-page">
// 			<h2 className="sf-security-title">
// 				{translations[language].account.security?.title || "Security"}
// 			</h2>

// 			{/* EMAIL INFO BLOCK */}
// 			<div className="sf-security-section">
// 				<h3 className="sf-security-section-title">
// 					{translations[language].account.security?.emailTitle || "Email"}
// 				</h3>

// 				<div className="sf-security-email-display">
// 					{email || "—"}
// 				</div>
// 			</div>

// 			{/* RESET PASSWORD */}
// 			<div className="sf-security-section">
// 				<h3 className="sf-security-section-title">
// 					{translations[language].account.security?.passwordTitle ||
// 						"Reset Password"}
// 				</h3>

// 				{success ? (
// 					<p className="sf-security-success">
// 						{translations[language].account.forgotPassword.success}
// 					</p>
// 				) : (
// 					<form
// 						className="sf-security-form"
// 						onSubmit={handleResetPassword}
// 					>
// 						<p className="sf-security-sub">
// 							{translations[language].account.forgotPassword.subtitle}
// 						</p>

// 						<div className="sf-security-row">
// 							<input
// 								type="email"
// 								className="sf-security-input"
// 								value={email}
// 								onChange={(e) =>
// 									setEmail(e.target.value)
// 								}
// 								required
// 							/>

// 							<button
// 								type="submit"
// 								className="sf-security-button"
// 								disabled={loading}
// 							>
// 								{loading
// 									? translations[language].account.forgotPassword
// 											.sending
// 									: translations[language].account.forgotPassword
// 											.send}
// 							</button>
// 						</div>
// 					</form>
// 				)}
// 			</div>

// 			{toast && <BannerMessage text={toast} />}
// 		</div>
// 	);
// };

// export default AccountSecurity;
